import { Route, Redirect } from 'react-router-dom';
import keycloakService from '../keycloakService';

const PrivateElement = ({ Component, requiredRoles, ...rest }) => {
  const isAuthenticated = keycloakService.isLoggedIn();
  const userHasRequiredRole = keycloakService.hasRole(requiredRoles);
  return isAuthenticated && userHasRequiredRole ? <Component {...rest} /> : <Redirect to="/" />;
};

const PrivateRoute = ({ component, requiredRoles, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return <PrivateElement {...props} Component={component} requiredRoles={requiredRoles} />;
      }}
    />
  );
};

export default PrivateRoute;
